export class OrderPrintOptions {
    public static NONE = 'NONE';
    public static ALL = 'ALL';
    public static REQUIRE_NAME = 'REQUIRE_NAME';
}
